var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isPeriodAnnually || _vm.isPeriodLifetime
      ? _c(
          "div",
          {
            staticClass:
              "save-text ib-handwriting-text text-center font-tragic-marker my-4",
          },
          [_vm._v(" " + _vm._s(_vm.saveText) + " ")]
        )
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "loader-price justify-content-center align-items-center",
        style: { "min-height": _vm.minHeight },
      },
      [_c("loader-payment")],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loading,
            expression: "!loading",
          },
        ],
        staticClass: "cross-price-wrapper",
        class: {
          dark: _vm.dark,
          "d-flex align-items-center justify-content-center":
            _vm.isPeriodMonthly,
        },
        style: { "min-height": _vm.minHeight },
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isPeriodMonthly,
                expression: "!isPeriodMonthly",
              },
            ],
            ref: "priceCrossRender",
            staticClass: "cross-price",
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.currency))]),
            _c("div", { staticClass: "price-without-currency" }, [
              _c("div", { staticClass: "number" }, [
                _vm._v(" " + _vm._s(_vm.finalCrossPrice) + " "),
              ]),
              _c("div", {
                ref: "priceCrossLineRender",
                staticClass: "cross-line",
                class: _vm.isPeriodLifetime ? "lifetime" : null,
              }),
            ]),
          ]
        ),
        _c(
          "div",
          {
            ref: "priceMainRender",
            staticClass: "d-flex justify-content-center animation",
          },
          [
            _c(
              "span",
              {
                staticClass: "price-sign font-outfit-semi-bold align-self-end",
              },
              [_vm._v(_vm._s(_vm.currency))]
            ),
            _c(
              "p",
              {
                staticClass:
                  "price-value position-relative d-inline-block font-outfit-medium m-0",
              },
              [_vm._v(" " + _vm._s(_vm.price) + " ")]
            ),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isPeriodMonthly,
                expression: "!isPeriodMonthly",
              },
            ],
            ref: "priceBilledRender",
            staticClass: "animation",
          },
          [
            _c("p", { staticClass: "price-period-desc mt-1 mb-0" }, [
              _vm.isPeriodLifetime
                ? _c(
                    "span",
                    {
                      staticClass: "text-uppercase font-outfit-semi-bold",
                      class: { lifetime: _vm.isPeriodLifetime },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("pages.pricing.oneTimePayment")) +
                          " "
                      ),
                    ]
                  )
                : _c("span", { class: { invisible: _vm.isPeriodMonthly } }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("pages.pricing.billedAnnually")) + " "
                    ),
                  ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }